<template>
	<div>
		<el-drawer title="商品查看记录" :visible.sync="drawer" wrapperClosable size="950px">
			<div class="tips mt-12">
				<p class="fz-14">
					<i class="el-icon-info yx-color-primary"></i>
					分享商品被查看后，生成查看记录
				</p>
			</div>
			<div class="pl-24 pr-24 mt-16">
				<el-table :data="gridData" header-row-class-name="table-header-row" row-class-name="table-row">
					<el-table-column label="查看人信息" min-width="150" align="center">
						<template slot-scope="{ row }">
							<div class="flex flex-align-start">
								<yx-avatar :src="row.avatar_url"></yx-avatar>
								<div class="ml-10">
									<div class="yx-color-text-primary fz-14">{{ row.nick_name }}</div>
									<div class="yx-color-text-regular fz-13">微信号：{{ row.wechat_account }}</div>
									<div class="yx-color-text-regular fz-13">手机号：{{ row.mobile }}</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column property="add_time" label="查看时间" min-width="120"></el-table-column>
					<el-table-column property="address" label="是否为联系人">
						<template slot-scope="{ row }">
							<span>{{ row.is_contact == '0' ? '否' : '是' }}</span>
						</template>
					</el-table-column>
					<el-table-column property="is_add_wx" min-width="100" label="是否添加微信好友">
						<template slot-scope="{ row }">
							<span>{{ row.is_add_wx == '0' ? '否' : '是' }}</span>
						</template>
					</el-table-column>
					<el-table-column property="opear" label="操作">
						<template slot-scope="{ row }">
							<div>
								<span
									class="pointer yx-color-primary"
									v-if="row.is_contact == '0' && $auth.hasPermi('system:talnetContacts:add-edit')"
									@click="addFun(row)"
									>添加联系人</span
								>
								<span
									class="pointer yx-color-primary"
									v-if="row.is_contact == '1' && $auth.hasPermi('system:talnetContacts:query')"
									@click="lookFun(row)"
									>查看联系人详情</span
								>
							</div>
						</template>
					</el-table-column>
					<template slot="empty">
						<span class="yx-color-text-primary fz-14">暂无人查看</span>
					</template>
				</el-table>
			</div>
		</el-drawer>
		<add-contact ref="addContact" :platformId="platformId" @refresh="getViewList"></add-contact>
	</div>
</template>
<script>
import addContact from '@/views/common/dialog/addContact.vue';
import { shareviewList } from '@/api/extenTecord';
export default {
	props: {
		platformId: {
			type: [Number, String],
			default: '',
		},
	},
	components: {
		addContact,
	},
	data() {
		return {
			drawer: false,
			gridData: [],
			row: {},
		};
	},
	methods: {
		async show(row) {
			this.row = row;
			this.getViewList();
			this.drawer = true;
		},
		async getViewList() {
			const { code, data } = await shareviewList({ share_id: this.row.id });
			if (code === 0) {
				this.gridData = data;
			}
		},
		addFun(row) {
			this.$refs.addContact.show(row.open_id, true);
		},
		lookFun(row) {
			const routeLink = this.$router.resolve({
				path: '/talentCRM/contacts',
				query: {
					contact_id: row.contact_id,
				},
			});
			window.open(routeLink.href, '_blank');
		},
		skipFun() {
			const routeLink = this.$router.resolve({
				path: '/talentCRM/clueSeas',
			});
			window.open(routeLink.href, '_blank');
		},
	},
};
</script>
<style lang="less" scoped>
.tips {
	padding: 10px 24px;
	p {
		padding: 10px;
		background: #e9f1ff;
		border: 1px solid #bdd5ff;
		border-radius: 2px;
	}
}
</style>
